import Cookies from 'js-cookie'
import { jwtDecode } from 'jwt-decode'
import LogTool from '../logger/logTools'

const log = new LogTool({ context: 'AuthTokens', enable: true, logLevel: 'warn' })

function resolveApiUrl(): string {
  const envApiUrl = process.env.REACT_APP_API_URL
  if (!envApiUrl) {
    throw new Error('API URL is not defined. Please set REACT_APP_API_URL environment variable.')
  }
  return envApiUrl
}

export function getApiBaseUrl(): string {
  const apiUrl = resolveApiUrl()
  return apiUrl.endsWith('/') ? apiUrl : `${apiUrl}/`
}

export function getApiBasePath(): string {
  return resolveApiUrl().replace(/\/$/, '')
}

export async function refreshAccessToken(): Promise<string | undefined> {
  const refreshToken = Cookies.get('refresh')
  if (!refreshToken) {
    return undefined
  }

  const baseUrl = getApiBaseUrl()

  try {
    const response = await fetch(`${baseUrl}v1/auth/token/refresh/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refresh: refreshToken }),
    })

    if (!response.ok) {
      throw new Error(response.statusText)
    }

    const data = await response.json()
    const decoded = jwtDecode(data.access)

    Cookies.set('access', data.access, {
      expires: new Date((decoded.exp as number) * 1000),
    })

    return data.access
  } catch (error) {
    log.error('Error refreshing access token:', error)
    return undefined
  }
}

export async function getAccessToken(forceRefresh = false): Promise<string | undefined> {
  if (!forceRefresh) {
    const existingToken = Cookies.get('access')
    if (existingToken) {
      return existingToken
    }
  }

  return refreshAccessToken()
}

